import { useState, useEffect } from 'react';
import Script from 'next/script';

function Libs() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (window) {
      window._shipScout = window._shipScout || [];
      window.Shopify = window.Shopify || {};
      window.Shopify.shop =
        process.env.SHOPIFY_DOMAIN || 'kryo-gear.myshopify.com';
      window.shipScoutCookieDomain = window.location.host;
    }
    setMounted(true);
  }, []);
  return (
    <>
      <style>{`.async-hide { opacity: 0 !important}`}</style>
      {mounted && (
        <Script
          type="text/javascript"
          id="shipscout-script"
          strategy="afterInteractive"
          src="https://web.shipscout.app/app.min.js"
        />
      )}
      <Script
        type="text/javascript"
        src="https://cdn.searchspring.net/intellisuggest/is.min.js"
      />
      <Script
        src="https://js.afterpay.com/afterpay-1.x.js"
        strategy="beforeInteractive"
      />  
    </>
  );
}

export default Libs;